import React from 'react'
import Donate from '../component/Donate'
import Header from '../component/Header'
import BottomBar from '../component/BottomBar'
import { FaAngleRight } from 'react-icons/fa6'
import { Helmet } from 'react-helmet-async'

function DonateNow() {
 
    const donationClick =()=>{
        const menu_dropdown = document.querySelector(".donate_header")
        menu_dropdown.classList.toggle("donate_dropDown");
    }

  return (
    <>
        <Helmet>
            <title>Donate Now | The Lord Nations Foundation</title>
            <meta name="description" content="Support The Lord Nations Foundation by making a donation today. Every contribution helps us continue our mission to transform lives and bring hope." />
        </Helmet>

        <div className='home' >
            <Header/>
            <div className='about_head_spacer'></div>
            <div className='donatebanner' >
                <div className='homebanner_overlay'>
                    <div className='homebanner_container'>
                        <div className='homebanner_text' >
                            <div className='donatenow_banner_label' >
                                <h3>DONATE NOW</h3>
                            </div>
                        </div>

                        <div className='danate_desk'>
                            <Donate/>
                        </div>
                    </div>
                </div>
            </div>

            <div className='about_sub' >
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h2>CHILDREN NEED YOUR HELP TODAY</h2>
                </div>

                <p>
                    Right now, children around the world are facing a global pandemic, compounded by poverty and conflict. For those living in hunger-stricken regions or struggling in desolate communities, every day is a fight for survival.
                </p>

                <p>
                    With your generous support, The Lord Nations Foundation works tirelessly to provide lifesaving aid, protection, and education—ensuring that every child, no matter where they are, gets the childhood they deserve.
                </p>

                <p style={{color:'#000', fontWeight:'700'}}>
                    Your gift today can provide lifesaving relief. <span style={{color:'#da291c'}} > Please donate now.</span>
                </p>
            </div>

            <div className='danate_mob'>
            <Donate/>
            </div>

            <div className='about_sub' >
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h2>For every $1 you donate we spend</h2>
                </div>

                <div className='about_sub_body'>
                    <div className='about_sub_body_img2'></div>

                        <div className='about_sub_body_writeup'>

                            <div className='about_sub_body_writeup_body donate_now_write_ups'>
                                <p>The Lord Nations Foundation stands side by side with children in the world's toughest places. Your donations make this support possible.</p>
                                <div onClick={()=>donationClick()} className='donate_now_write_ups_btn'>
                                <p>DONATE NOW</p>
                                    <FaAngleRight/>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>

            <BottomBar/>
        </div>
    </>
  )
}

export default DonateNow